// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"12481bb9","113":"eb9f0477","165":"ef69c41d","166":"af788cb2","233":"6f72dcf5","278":"7e49b6ba","322":"2218a494","463":"b23277d2","566":"63acfcd4","872":"de2278e7","928":"e9819c49"}[chunkId] + ".chunk.js";
};